import { BaseDto } from './base.dto'
import { TranslationDto } from './translation.dto'

export class LotNumberManagementDto extends BaseDto {
  public key?: string
  public geojson?: Record<string, unknown>
  public mallId?: string
  public mallName?: TranslationDto
  public floorMapInteractiveId?: string
  public floorName?: string
  public floorCode?: string
  public offlineTenantId?: string | null
  public tenantName?: TranslationDto | null

  public static create(data?: Partial<LotNumberManagementDto>): LotNumberManagementDto {
    const instance = new LotNumberManagementDto()
    if (data) {
      Object.assign(instance, data)
    }
    return instance
  }
}

export class UpdateLotNumberManagementDto {
  public offlineTenantId: string | null
}

export class LotNumberTenantOptionDto {
  public id: string
  public name: TranslationDto
}

export class ExportLotNumberManagementDto {
  public mallId?: string
  public floorId?: string
  public search?: string
  public tenantName?: string
}
